setInterval(function() {
  var soldoutdata=$(".page-content.page-content--product button.btn.btn--full.add-to-cart span").text().trim();
  if(soldoutdata=="Sold Out"){
    $(".klSP-title").removeClass("hide");
  }
  else{
    $(".klSP-title").addClass("hide");   
  }

  // preorder  
  
  if(soldoutdata=="Pre Order Now"){
    $(".m-preorder-benefits").removeClass("hide");
    $(".KLSP-variation-availability").removeClass("hide");
  
   

    var pre_comp_data = parseFloat($('.product-single__meta .product-block.product-block--price').attr('data-comp-price'));
    var final_price_d = parseFloat($('.product-single__meta .product-block.product-block--price').attr('data-sl-price'));

    var relsave = pre_comp_data - final_price_d;
    $("span.KLSP_chg_vl").text(Math.round(relsave.toFixed(2)));

  }else{
    $(".m-preorder-benefits").addClass("hide");
    $(".KLSP-variation-availability").addClass("hide");
  }
  // Sticky button code
  $(".grid__item.medium-up--two-fifths.PDP_info button.button.btn.SPKl-add").text(soldoutdata);

  var sticky_da=$(".grid__item.medium-up--two-fifths.PDP_info button.btn.btn--full.add-to-cart span").text();
  $(".sticky-cart button.button.btn.SPKl-add").text(sticky_da);
  
}, 100);

$(".grid__item.medium-up--two-fifths.PDP_info .button.btn.SPKl-add").click(function(){
  $(".page-content.page-content--product button.btn.btn--full.add-to-cart span").trigger("click");
})

$(".sticky-cart .button.btn.SPKl-add").click(function(){
  $(".page-content.page-content--product button.btn.btn--full.add-to-cart span").trigger("click");
})

$(window).scroll(function() {
  var $trustBadge = $(".Custom_trust_badge.product-block");
  var $stickyCartContainer = $(".SPKL-sticky-cart-container");
  if ($trustBadge.length > 0 && $stickyCartContainer.length > 0) {
    var scrollPosition = $(window).scrollTop(); 
    var trustBadgeOffset = $trustBadge.offset().top; 
    if (scrollPosition > trustBadgeOffset) {
      $stickyCartContainer.removeClass("hide");
    }else {
      $stickyCartContainer.addClass("hide");
    }
  }
});



function updateATCText(currentVid) {
  setTimeout(function () {
    $(".InventoryManagment .inner-InventoryManagment").each(function () {
      var vid = $(this).attr('data-id');
      var inventory_count = parseInt($(this).attr('data-inventory'), 10);
      var isPreOrder = $(this).hasClass('pre-order-data');

      if (currentVid == vid) {
        if (isPreOrder && inventory_count <= 0) {
          setATC("Pre Order Now");
        } else if (!isPreOrder && inventory_count > 0) {
          setATC("Add to Cart");
        } else {
          setATC("Sold Out");
        }

        if (inventory_count < 0 && !isPreOrder) {
          $('.notify-stock-button').show();
        } else {
          $('.notify-stock-button').hide();
        }
      }
    });
  }, 100); // 👈 adjust if needed (150–300ms is ideal)
}


function setATC(text) {
  const $btn = $(".page-content.page-content--product [data-product-blocks] button[data-add-to-cart] span");
  $btn.text(text);
  $btn.attr('data-default-text', text);
}

$(document).ready(function () {
  var initialVid = $('input[name="id"]').val();

  setTimeout(function () {
    updateATCText(initialVid);
  }, 100); // 👈 waits for Shopify variant init
});

$(document).on("click", "[data-product-blocks] .variant-wrapper .variant-input", function() {
  let chngeDataVMain = [];
  var teste = $(this).attr("data-value");
  var currentVid = $(this).attr('data-v');
  $(this).closest(".variant-wrapper").attr("d-chnges", teste);
  setTimeout(function() {
    $(".PDP_variant_picker .product-block .variant-wrapper").each(function() {
      chngeDataVMain.push($(this).attr("d-chnges"));
    });
    
    let chngeDataVMainText = chngeDataVMain.join(' / ').toLowerCase().trim();

    $(".InventoryManagment .inner-InventoryManagment").each(function() {
      var chngeDataVOld = $(this).attr("v-title").toLowerCase().trim();
      var vid = $(this).attr('data-id');
      var inventory_count = $(this).attr('data-inventory');
      var checkifpreorder = 0;
      if(currentVid == vid){

        if($(this).hasClass('pre-order-data')){
          checkifpreorder = 1;
        }
       

        if(checkifpreorder == 1 && inventory_count <= 0){
          $(".page-content.page-content--product [data-product-blocks] button[data-add-to-cart] span").text("Pre Order Now");
          $(".page-content.page-content--product [data-product-blocks] button[data-add-to-cart] span").attr('data-default-text', 'Pre Order Now');
          $('input[name="properties[This item is on]"]').val('pre-order');
        }else if(checkifpreorder == 0 && inventory_count > 0){
          $(".page-content.page-content--product [data-product-blocks] button[data-add-to-cart] span").text("Add to Cart");
          $(".page-content.page-content--product [data-product-blocks] button[data-add-to-cart] span").attr('data-default-text', 'Add to Cart');
          $('input[name="properties[This item is on]"]').val('');
        }else{
          $(".page-content.page-content--product [data-product-blocks] button[data-add-to-cart] span").text("Sold Out");
          $(".page-content.page-content--product [data-product-blocks] button[data-add-to-cart] span").attr('data-default-text', 'Sold Out');
          $('input[name="properties[This item is on]"]').val('');
        }
      }
      
      if (currentVid === vid) {
        if(inventory_count < 0 && checkifpreorder == 0){
          $('.notify-stock-button').show();
        }else{
          $('.notify-stock-button').hide();
        }
      }
      
    });
  }, 50);
});


$(document).on("click", ".modal .variant-wrapper .variant-input", function() {
  let chngeDataVMain = [];
  var teste = $(this).attr("data-value");
  var currentVid = $(this).attr('data-v');
  $(this).closest(".variant-wrapper").attr("d-chnges", teste);
  setTimeout(function() {
    $(".PDP_variant_picker .product-block .variant-wrapper").each(function() {
      chngeDataVMain.push($(this).attr("d-chnges"));
    });
    
    let chngeDataVMainText = chngeDataVMain.join(' / ').toLowerCase().trim();

    $(".InventoryManagment .inner-InventoryManagment").each(function() {
      var chngeDataVOld = $(this).attr("v-title").toLowerCase().trim();
      var vid = $(this).attr('data-id');
      var inventory_count = $(this).attr('data-inventory');
      var checkifpreorder = 0;
      if(currentVid == vid){

        if($(this).hasClass('pre-order-data')){
          checkifpreorder = 1;
        }
        

        if(checkifpreorder == 1 && inventory_count <= 0){
          $(".modal .page-content.page-content--product [data-product-blocks] button[data-add-to-cart] span").text("Pre Order Now");
          $(".modal .page-content.page-content--product [data-product-blocks] button[data-add-to-cart] span").attr('data-default-text', 'Pre Order Now');
        }else if(checkifpreorder == 0 && inventory_count > 0){
          $(".modal .page-content.page-content--product [data-product-blocks] button[data-add-to-cart] span").text("Add to Cart");
          $(".modal .page-content.page-content--product [data-product-blocks] button[data-add-to-cart] span").attr('data-default-text', 'Add to Cart');
        }else{
          $(".modal .page-content.page-content--product [data-product-blocks] button[data-add-to-cart] span").text("Sold Out");
          $(".modal .page-content.page-content--product [data-product-blocks] button[data-add-to-cart] span").attr('data-default-text', 'Sold Out');
        }
      }
      
      if (currentVid === vid) {
        if(inventory_count < 0 && checkifpreorder == 0){
          $('.notify-stock-button').show();
        }else{
          $('.notify-stock-button').hide();
        }
      }
      
    });
  }, 100);
});

jQuery(document).ready(function ($) {

  function updateNotifyButton(currentVid) {
    $(".InventoryManagment .inner-InventoryManagment").each(function () {
      const vid = $(this).attr("data-id");
      const inventory_count = parseInt($(this).attr("data-inventory"), 10) || 0;
      const isPreorder = $(this).hasClass("pre-order-data");

      // ✅ Show only when sold out (inventory 0) and not preorder
      if (currentVid === vid) {
        if (inventory_count <= 0 && !isPreorder) {
          $(".notify-stock-button").show();
        } else {
          $(".notify-stock-button").hide();
        }
      }
    });
  }

  // ✅ Initial load check
  const initialVid = $(".custom_main_data_sp").attr("data-current-vid");
  if (initialVid && initialVid !== "undefined" && initialVid !== "") {
    updateNotifyButton(initialVid);
  } else {
    $(".notify-stock-button").hide();
  }

  // ✅ On variant click/change
  $(".variant-wrapper .variant-input").on("click", function () {
    const currentVid = $(this).attr("data-v");
    setTimeout(() => updateNotifyButton(currentVid), 100);
  });

});


